<template>
    <div class="story-maker-sticker story-maker-sticker-survey" :class="{edit: isSelected}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="stickerInstance.nextColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div class="sticker sticker-survey">
            <div 
                class="survey-header"
                v-if="isSelected || stickerInstance.data.question"
                :style="{ 
                    backgroundColor: stickerInstance.data.color
                }"
            >
                    <textarea @input="resize" :value="stickerInstance.data.question" ref="textarea_question" modelPath="question" cols="20" rows="2" wrap="hard" maxlength="100" :placeholder="$t('dash.post-creator.story.survey-question')" :readonly="!isSelected"></textarea>
            </div>
            <div class="choises">
                <div class="choise"
                    v-for="(_,index) in Array.from({ length:4})"
                    v-if="(isSelected || stickerInstance.data.responses[index]) && (index < 3 || (stickerInstance.data.responses[2] || stickerInstance.data.responses[3]))"

                    :class="{optional: index >= 2 && !stickerInstance.data.responses[index]}
                ">
                    <textarea
                        v-if="isSelected"
                        cols="20"
                        rows="2"
                        wrap="hard"
                        maxlength="100"
                        :placeholder="[$t('dash.post-creator.story.survey-yes'), $t('dash.post-creator.story.survey-no'), $t('dash.post-creator.story.survey-add-option'), $t('dash.post-creator.story.survey-add-option')][index]"
                        @input="resize"
                        :value="stickerInstance.data.responses[index] ? stickerInstance.data.responses[index] : ''"
                        :modelPath="`responses.${index}`"
                        ref="textarea_choice"
                        >
                    </textarea>

                    <textarea
                        v-else
                        cols="20"
                        rows="2"
                        wrap="hard"
                        maxlength="100"
                        :placeholder="[$t('dash.post-creator.story.survey-yes'), $t('dash.post-creator.story.survey-no'), $t('dash.post-creator.story.survey-add-option'), $t('dash.post-creator.story.survey-add-option')][index]"
                        v-model="stickerInstance.data.responses[index]"
                        :readonly="true"
                        @mousedown.prevent
                        @selectstart.prevent
                        :modelPath="`responses.${index}`"
                        ref="textarea_choice"
                        >
                    </textarea>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script>
    import Vue from 'vue';
    import { EventBus } from '@/event-bus';

    export default {
        props: {
            id: Number | String,
            stickerInstance: {
                type: Object,
                required: true
            },
            isSelected: Boolean,
        },

        data() {
            return {
            }
        },

        created() {
            Vue.observable(this.stickerInstance.data.responses)
        },

        mounted () {
             this.$nextTick(()=> {
                this.resizeAll()
            })
        },
 

        methods: {
            unselected() {
                console.log('unselected survey')
                this.stickerInstance.cleanResponses()
            },

            finish(event) {
                if (this.isSelected && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    this.$emit('unselect')
                }
            },

            resizeAll() {
                this.resize({target: this.$refs[`textarea_question`]})
                this.$refs[`textarea_choice`].forEach(textarea => {
                    this.resize({target: textarea})
                });
            },

            resize(e) {
                const maxLine = 2
                let element = e.target;
               
                const modelPath = element.getAttribute('modelPath').split('.')
                const modelname = modelPath.pop();
                const modelObject = modelPath.reduce((acc, k) => acc[k], this.stickerInstance.data);
               
                if (!modelname) return

                const lineHeight =  parseFloat(getComputedStyle(element).lineHeight);

                element.style.height = `${lineHeight}px`;
                const scrollHeight = element.scrollHeight;
             
                if (scrollHeight >= lineHeight*(maxLine+1)) {
                    element.style.height = `${lineHeight * maxLine}px`;
                    element.value = modelObject[modelname]
                }else{
                    this.$set(modelObject, modelname, element.value)
                    element.style.height = Math.min(scrollHeight,lineHeight * maxLine) + "px";
                }
            },
        },

        watch: {
            isSelected(value) {
                if (value) {

                }else{
                    this.unselected()
                }
            }
        },

        beforeDestroy() {
            EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
        }
    }
</script>

<style lang="scss" scoped>

</style>
<!-- https://vuejs.org/guide/built-ins/transition-group -->